import { type GetRepositoriesResponse } from './types'
import { type ExternalGitProvider } from 'types/ExternalGitProvider'

export const useGetRepositoriesResponses: Record<
  ExternalGitProvider,
  GetRepositoriesResponse
> = {
  github: {
    repositories: [
      {
        id: '617541101',
        name: 'github-test-repository',
        fullName: 'test-org/github-test-repository',
        owner: {
          id: 'github-owner-id',
          name: 'test-org',
          type: 'ORGANISATION'
        }
      },
      {
        id: '413541701',
        name: 'github-test-repository-2',
        fullName: 'test-user/github-test-repository-2',
        owner: {
          id: '1654861417',
          name: 'test-user',
          type: 'USER'
        }
      }
    ]
  }
}
